import { createContext } from 'react';

import type { WebSocketMessage } from '@famecreator/shared-types/websocket';

type MessageHandler = (message: WebSocketMessage) => void;

export interface WebSocketContextValue {
  isConnected: boolean;
  connectionState: 'connecting' | 'connected' | 'disconnected' | 'error';
  processingCount: number;
  // Methods for message subscription
  subscribeToMessages: (id: string, handler: MessageHandler) => void;
  unsubscribeFromMessages: (id: string) => void;
}

export const WebSocketContext = createContext<WebSocketContextValue | null>(null);
